import React from "react";
import RemoveSupplyPublicForm from "./RemoveSupplyPublicForm";
import RemoveSupplyPublicAgreementElectricity from "./RemoveSupplyPublicAgreementElectricity";
import ReadOnlyTextField from "../FormComponents/ReadOnlyTextField";
import { useRemoveSupplyPublicForm } from "./hooks/useRemoveSupplyPublicForm";
import { Text } from "@origin-digital/ods-core";
import { SupplyConfigurationType } from "./hooks/type";
import { getPublicRemoveSupplySuccessUrl } from "src/utils/routeUtils";

export const electricitySupplyConfiguration: SupplyConfigurationType = {
  initialFormData: {
    journeyId: "",
    postcode: "",
    scheduleDate: null,
    meterNumber: "",
    nmi: "",
  },
  createSetFormDataAction: (idValue) => (prev) => ({
    ...prev,
    nmi: idValue,
  }),
  getSuccessUrl: () => getPublicRemoveSupplySuccessUrl("elec"),
};

export const RemoveSupplyPublicFormElectricity = () => {
  const hookProps = useRemoveSupplyPublicForm(electricitySupplyConfiguration);
  return (
    <RemoveSupplyPublicForm
      {...hookProps}
      agreement={
        <RemoveSupplyPublicAgreementElectricity feeInfo={hookProps.feeInfo} />
      }
      nmiOrMirnField={
        <ReadOnlyTextField label="NMI" value={hookProps.formData.nmi} />
      }
      instructionText={
        <Text>
          To proceed with the permanent disconnection of the electricity meter
          and supply, please enter the reference number and the postcode of the
          property in question. You can find these details in the email/SMS
          you've received.
        </Text>
      }
    />
  );
};
